import entityBase from "entityBase";
import { CustomObservables } from "CustomObservables";
import * as ko from "knockout";
import * as moment from "moment";
import { attachment } from "../organized/attachment/attachment";

export class screenNote extends entityBase {
  attachment: KnockoutObservable<any>;
  journal_source_type_label_value: KnockoutObservable<any>;
  journal_source_type_label_id: KnockoutObservable<any>;
  journal_source_type: KnockoutObservable<any>;
  request_id: KnockoutObservable<any>;
  task_id: KnockoutObservable<any>;
  line_descr: KnockoutObservable<any>;
  bodyText: KnockoutObservable<any>;
  humanDate: KnockoutComputed<string>;
  formattedcreated_dttm: KnockoutComputed<{}>;
  created_by: KnockoutObservable<string>;
  created_dttm: KnockoutObservable<Date>;
  constructor(item) {
    super();
    this.created_by = ko.observable(item.created_by);

    this.created_dttm = ko.observable(this.formatJSONDate(item.created_dttm));
    this.formattedcreated_dttm = CustomObservables.formattedDateTimeObservable(this.created_dttm);
    this.humanDate = ko.pureComputed(() => {
      const format = "YYYY-MM-DD HH:mm:ss";
      const dateFormatted = moment(this.created_dttm()).format(format);
      const humanDateFormatted = moment(this.created_dttm()).fromNow();
      return `${humanDateFormatted} (${dateFormatted})`;
    });
    this.journal_source_type = ko.observable(item.journal_source_type);
    this.journal_source_type_label_id = ko.observable(item.journal_source_type_label_id);
    this.journal_source_type_label_value = ko.observable(item.journal_source_type_label_value);
    this.request_id = ko.observable(item.request_id);
    this.task_id = ko.observable(item.task_id);
    this.bodyText = ko.observable(item.bodyText);
    this.line_descr = ko.observable(item.line_descr);

    this.attachment = <KnockoutObservableArray<attachment>>this.loadRelation(item, attachment, "attachment", "array");
  }
}
